<script setup lang="ts">
import { SectionFormat } from '@apparatix/types/AccountProfiles';

type Props = {
  format: SectionFormat;
}

const props = defineProps<Props>();
</script>
<template>
  <slot v-if="props.format === 'blob'" name="blob" />
  <slot v-if="props.format === 'composite-list'" name="composite-list" />
  <slot v-if="props.format === 'list'" name="list" />
  <slot v-if="props.format === 'table'" name="table" />
  <slot v-if="props.format === 'fallback'" name="fallback" />
</template>
